import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-support',
  templateUrl: './online-support.component.html',
  styleUrls: ['./online-support.component.css']
})
export class OnlineSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
